import React from 'react';
import styled, { css } from 'styled-components';
import { FocusLink } from '../../FocusLink';
import { useIsMobileNavigation } from '../hooks/useIsMobileNavigation';
import { HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT } from '../constants';
const StyledFocusLink = styled(FocusLink) `
  ${props => props.isMobile &&
    css `
      margin: 1.25rem ${HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT};
      width: calc(100% - 2 * ${HORIZONTAL_DISTANCE_NAV_ITEMS_VIEWPORT});
    `};
  /* Prevent word wraps */
  white-space: nowrap;

  &:hover {
    color: ${props => props.theme.BrandPrimary};
  }

  ${props => props.isActive &&
    css `
      color: ${props => props.theme.BrandPrimary};

      &:hover {
        color: ${props => props.theme.BrandPrimaryHover};
      }
    `};
`;
export const NestedNavigationItem = ({ children = null, isActive, target }) => {
    const isMobileNavigation = useIsMobileNavigation();
    return (React.createElement("li", null,
        React.createElement(StyledFocusLink, { isActive: isActive, isMobile: isMobileNavigation, to: target }, children)));
};
